/**
 * Normalizes URLs by replacing dynamic parts with placeholders
 * - UUIDs are replaced with `:id`
 * - Numeric IDs are replaced with `:num`
 * - Query parameters are removed
 */
export function normalizeUrl(url: string): string {
  // Remove query parameters
  const baseUrl = url.split("?")[0];

  const uuidPattern =
    /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
  let normalizedUrl = baseUrl.replace(uuidPattern, ":id");

  const numericIdPattern = /\/\d+(\/?|$)/g;
  normalizedUrl = normalizedUrl.replace(numericIdPattern, "/:num$1");

  return normalizedUrl;
}
